var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.strap.url && _vm.dial.cadran.url)?_c('div',{staticClass:"strap-collage"},[_c('lazy-image',{ref:"picture",attrs:{"class-name":_vm.dial.soldat
        ? 'product-header-item-image soldat'
        : 'product-header-item-image',"item":_vm.strap}}),_vm._v(" "),_c('lazy-image',{ref:"dialPicture",attrs:{"item":_vm.dial.cadran,"draggable":'false',"class-name":_vm.dial.soldat
        ? 'product-header-item-image over-image soldat'
        : 'product-header-item-image over-image'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }